import React, { useContext, useEffect } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import DealsBoard from "../../components/deals/DealsBoardPage";
import CreateDealPage from "../../components/deals/createDeals/CreateDealPage";
import DealInformationPage from "../../components/deals/DealInformationPage/DealInformationPage";
import CreateInvestors from "../../components/deals/createInvestors";
import ViewInvestors from "../../components/deals/viewInvestors/DealInvestorDetailPage";
import DealCompanyInformationPage from "../../components/deals/CompanyInformationPage/DealCompanyInformationPage";
import { PopupsContext } from "../../helpers/contexts/popupsContext";
import ViewDealDocumentPage from "../../components/deals/dealDocuments/ViewDealDocumentPage/ViewDealDocumentPage";
import SignDealDocumentPage from "../../components/deals/dealDocuments/SignDealDocumentPage/SignDealDocumentPage";
import ViewDealDocumentWithSignaturesPage from "../../components/deals/dealDocuments/ViewDealDocumentWithSignaturesPage/ViewDealDocumentWithSignaturesPage";
import YourSignaturesPage from "../../components/deals/closing/your-signatures/YourSignaturesPage";
import DealDocumentsPage from "../../components/deals/dealDocuments/DealDocumentsPage/DealDocumentsPage";
import SignatureAndWireTrackerPage from "../../components/deals/closing/SignatureAndWireTrackerPage/SignatureAndWireTrackerPage";
import DealInvestorsPage from "../../components/deals/investorsDeals/DealInvestorsPage";
import SignatureBlockConfigurationRouter from "../../components/deals/signatureBlocks/SignatureBlockConfigurationRouter";
import SignatureBlockConfigurationForInvestmentRouter from "../../components/deals/signatureBlocks/SignatureBlockConfigurationForInvestmentRouter";

export const isPathnameDocument = (pathname: string) => {
  return new RegExp(/documents\/\d+/).test(pathname);
};

export type DealRouteProps = { orgId: string; dealId: string };

export type DealDocumentRouteProps = DealRouteProps & { documentId: string };

const DealsRoutes = (props) => {
  const {
    location: { pathname },
    match: {
      params: { orgId },
    },
  } = props;

  const context = useContext(PopupsContext);

  useEffect(() => {
    if (
      pathname.indexOf("deals") > -1 &&
      pathname !== "/" + orgId + "/deals/"
    ) {
      const isDocumentSigning = isPathnameDocument(pathname);

      if (isDocumentSigning) {
        context.subHeaderVisibilitySwitch(false);
      } else {
        context.subHeaderVisibilitySwitch(true);
      }
    }
  }, [pathname]);

  return (
    <Switch>
      <Route exact path={`/`} component={DealsBoard} />
      <Route exact path={`/:orgId/deals/`} component={DealsBoard} />
      <Route
        exact
        path={`/:orgId/deals/before-create/`}
        component={DealsBoard}
      />
      <Route
        exact
        path={`/:orgId/deals/create/:description?`}
        component={CreateDealPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/edit/deal-information`}
        component={DealInformationPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/edit/company-information`}
        component={DealCompanyInformationPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/edit/investors`}
        component={DealInvestorsPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/edit/investors/create`}
        component={CreateInvestors}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/edit/investors/edit/:investor`}
        component={ViewInvestors}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/investors/:dealInvestorId/investment/:dealLegalEntityInvestmentId/signature-block`}
        component={SignatureBlockConfigurationForInvestmentRouter}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/deal-legal-entity/:dealLegalEntityId/signature-block`}
        component={SignatureBlockConfigurationRouter}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/edit/signatures`}
        component={SignatureAndWireTrackerPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/edit/your-signatures`}
        component={YourSignaturesPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/documents`}
        component={DealDocumentsPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/documents/:documentId`}
        component={ViewDealDocumentPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/documents/:documentId/sign/:dealDocumentSignerId`}
        component={SignDealDocumentPage}
      />
      <Route
        exact
        path={`/:orgId/deals/:dealId/documents/:documentId/signatures`}
        component={ViewDealDocumentWithSignaturesPage}
      />
    </Switch>
  );
};

export default withRouter(DealsRoutes);
